import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { UserUnion } from '@airgram/web';
import { TranslateService } from '@ngx-translate/core';
import { ChatModel } from '@src/models';
import { TelegramMessengerService } from '@src/app/modules/telegram';

@Component({
  selector: 'telegram-bot',
  templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BotComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly messengerService = inject(TelegramMessengerService);
  private readonly translateService = inject(TranslateService);

  @Input() bot?: UserUnion;
  @Input() chat?: ChatModel;
  organisation: any;
  botStatus: string = this.translateService.instant('common.labels.bot');

  onChangeNotificationsToggleValue() {
    if (this.chat?.id) {
      this.messengerService.api
        .setChatNotificationSettings(this.chat.id, this.chat.notificationSettings.muteFor !== 0)
        .then(() => this.cdr.markForCheck());
    }
  }
}
